import * as React from 'react';
import { Button, Card, Col, Divider, Modal, notification, Row, Table, Alert } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';

import BusinessQuery from '../../components/Query/Business';
import BusinessDetail from './BusinessDetail';
import { Title } from '../../components/Layout/components';
import NotFoundPage from '../NotFound/NotFound';

interface IBusinessTableProps extends RouteComponentProps {
  domain: string;
  businessId?: string;
}

interface IBusinessTableState {
}

class BusinessTable extends React.Component<IBusinessTableProps, IBusinessTableState> {

  constructor(props: IBusinessTableProps) {
    super(props);
  }

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  public render() {
    return (
      <Row>
        <Col span={24}>
          <BusinessQuery>
            {({ business, deleteBusiness, createBusiness, updateBusiness }: any) => {
              return this.renderData(
                business,
                updateBusiness,
                createBusiness,
                deleteBusiness,
                business.refetch
              );
            }}
          </BusinessQuery>
        </Col>
      </Row>
    );
  }

  private renderData(
    business: any,
    updateBusiness: Function,
    createBusiness: Function,
    deleteBusiness: Function,
    refetch: Function
  ) {
    if (business && !business.loading) {

      // formulář
      if (this.props && this.props.businessId) {
        const selectedBusiness = business.business.find((d: GQL.IBusiness) => d.id === this.props.businessId) || undefined;
        if (this.props.businessId !== 'new' && !selectedBusiness) {
          return <NotFoundPage domain={this.props.domain} />
        }
        return (
          <BusinessDetail
            business={business.business.find((s: GQL.IBusiness) => s.id === this.props.businessId) || undefined}
            onSave={a => this.upsert(a, updateBusiness, createBusiness, refetch)}
            onCancel={() => this.cancel()}
          />
        );
      }

      return (
        <div>
          <Title>Business</Title>
          <Divider />
          <Link className="ant-btn" to={this.getLink('new')}>Create new business</Link>
          <Table
            rowKey={(record: any) => record.id}
            dataSource={business.business}
            defaultExpandAllRows={true}
            style={{ marginTop: '20px' }}
          >
            <Table.Column
              title="Title"
              dataIndex="name"
              key="name"
            />
            <Table.Column
              title="Country"
              dataIndex="country"
              key="country"
            />
            <Table.Column
              title="Default"
              dataIndex="default"
              key="default"
              width={100}
              align="center"
              render={(u, row: GQL.IBusiness) => {
                return (
                  <span>
                    {row.default 
                      ? <CheckOutlined style={{ color: '#52c41a', fontSize: 20 }} />
                      : <CloseOutlined style={{ fontSize: 20 }} />}
                  </span>
                );
              }}
            />
            <Table.Column
              title="Actions"
              dataIndex="actions"
              key="actions"
              width={180}
              align="center"
              render={(u: any, row: any) => this.renderActions(u, row, deleteBusiness, refetch)}
            />
          </Table>
        </div>
      );
    }

    return (
      <div>
        <Divider />
        <Card loading={true} title="Loading business ..." style={{ width: '100%' }} />
      </div>
    );
  }

  private renderActions(u: any, business: GQL.IBusiness, deleteBusiness: Function, refetch: Function) {
    return (
      <div>
        <Link className="ant-btn" type={'dashed'} to={this.getLink(business.id)}>
          Edit
        </Link>
        <Divider type={'vertical'} />
        <Button danger={true} onClick={() => this.delete(business, deleteBusiness, refetch)}>
          Delete
        </Button>
      </div>
    );
  }

  private delete(business: GQL.IBusiness, deleteBusiness: Function, refetch: Function) {
    Modal.confirm({
      title: `Delete ${business.name}?`,
      content: (
        <span>
          Are you sure you want to delete business <strong>{business.name}</strong>?
        </span>
      ),
      onOk: () => {
        return deleteBusiness({
          variables: {
            id: business.id
          }
        }).then(() => refetch());
      }
    });
  }

  private upsert(
    business: GQL.IBusiness,
    updateBusiness: Function,
    createBusiness: Function,
    refetch: Function
  ) {
    if (business != undefined) {
      const variables = {
        id: business.id,
        business: {
          default: business.default || false,
          name: business.name,
          company: business.company,
          street: business.street,
          houseNumber: business.houseNumber,
          addressLine1: business.addressLine1,
          addressLine2: business.addressLine2,
          city: business.city,
          zip: business.zip,
          countyState: business.countyState,
          country: business.country,
          vatNumber: business.vatNumber,
          registrationNumber: business.registrationNumber,
          phone: business.phone,
          email: business.email,
          emailForNotification: business.emailForNotification,
          web: business.web,
          bankName: business.bankName,
          iban: business.iban,
          swift: business.swift,
          bankAccountNumber: business.bankAccountNumber,
        }
      };

      if (business.id) {
        return updateBusiness({ variables })
          .then(() => refetch())
          .then(() => this.cancel())
          .then(() =>
            notification['success']({
              message: 'Info',
              description: `Business "${variables.business.name}" has been updated.`
            })
          );
      }

      createBusiness({ variables })
        .then(() => refetch())
        .then(() => this.cancel())
        .then(() =>
          notification['success']({
            message: 'Info',
            description: `Business "${variables.business.name}" has been created.`
          })
        );
    }
  }

  private getLink(recordId: string | null) {
    return `/${this.props.domain}/application/business${recordId ? `/${recordId}` : ''}`;
  }

  private cancel() {
    this.props.history.push(this.getLink(null));
  }
}

export default withRouter(BusinessTable);



// WEBPACK FOOTER //
// ./src/scenes/Business/BusinessTable.tsx